module.exports = __webpack_public_path__ + "static/media/othersScreen.0b85f5bd.png";